export const LUXOTTICA_USER_SPECIAL_TYPE_ID = 5;

export const COMPANY_FEATURE_FLAGS = {
  SMB_SIMPLIFIED_DOMESTIC_SHIPPING_FLOW: 'smbSimplifiedDomesticShippingFlow',
  DIRECT_PRINT_NODE_FEATURE: 'directPrintNodeFeature',
  MULTIPLE_SHIPMENTS_AUTOMATIC_REPORTS_DISABLED: 'multipleShipmentsAutomaticReportsDisabled',
  HS_CODE_10_DIGIT: 'hsTenDigitCode',
} as const;
